import React, { useState } from "react";
import { FaPhone, FaEnvelope } from "react-icons/fa";
import heroBg from "../../assets/hero-bg.png"; 
import ContactusService from "../../core/service/contactusService";
import "./ContactUsComponent.css";

const contactService = new ContactusService();

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    companyName: "", 
    designation: "",
    phoneNumber: "", 
    email: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!formData.name || !formData.email) {
      setError("Name and email are required.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await contactService.submitContact(formData);
      if (response.data && response.data.responseCode === 201) {
        setSuccess("Form submitted successfully!");
        setFormData({
          name: "",
          companyName: "",
          designation: "",
          phoneNumber: "",
          email: "",
        });
      } else {
        const errorMsg =
          response.data?.message || "Failed to submit. Please try again.";
        setError(errorMsg);
      }
    } catch (error) {
      if (error.response) {
        const errorMsg =
          error.response.data?.message || "Server error occurred.";
        setError(errorMsg);
      } else if (error.request) {
        setError(
          "No response from server. Please check your internet connection."
        );
      } else {
        setError("Something went wrong. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* 1. Hero Section */}
      <div className="contact-hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-content">
          <h1 className="contact-title">CONTACT US</h1>
        </div>
      </div>

      {/* 2. Main Content Section */}
      <div className="contact-main-wrapper">
        <div className="contact-container">
          
          {/* Left Side: Form */}
          <div className="contact-form-container">
            <h2 className="form-header-text">Get in touch with us</h2>
            
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="companyName"
                  placeholder="Company name"
                  value={formData.companyName}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="designation"
                  placeholder="Designation"
                  value={formData.designation}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  name="phoneNumber"
                  placeholder="Phone number"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>

              {error && <div className="error-message">{error}</div>}
              {success && <div className="success-message">{success}</div>}

              <button type="submit" className="contact-form-submit" disabled={isLoading}>
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>

          {/* Right Side: Contact Info */}
          <div className="contact-info-container">
            <div className="contact-info-item">
              <div className="icon">
                <FaPhone />
              </div>
              <div className="info-content">
                <p className="info-text">+91 8904871481</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="icon">
                <FaEnvelope />
              </div>
              <div className="info-content">
                <p className="info-text">info@cred-tech.org</p>
                <p className="info-text">credtech2020@gmail.com</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactPage;
